import { useCallback } from 'react';

import { Globe } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

import { LabeledSwitch, Text } from '@/_components';
import { WidgetLayout } from '@/_containers';
import { dashboardWidgetsPermissionConfig } from '@/_shared';

export function Layout({
  children,
  className,
  fallback,
  managedOnly,
  setManagedOnly,
  expiredNumber = 0,
}: {
  children: React.ReactNode;
  className?: string;
  fallback?: React.ReactNode;
  managedOnly?: boolean;
  expiredNumber?: number;
  setManagedOnly?: (value: boolean) => void;
}) {
  const handleToggleChange = useCallback(
    (checked: boolean) => {
      setManagedOnly?.(checked);
    },
    [setManagedOnly]
  );

  const headerRight = useCallback(() => {
    return (
      <div className="3xl:pr-4 pr-4">
        <LabeledSwitch
          checked={managedOnly}
          onCheckedChange={handleToggleChange}
          labelPlacement="before"
          label="Managed"
        />
      </div>
    );
  }, [handleToggleChange, managedOnly]);

  const footerLeft = useCallback(() => {
    return (
      <div>
        <Text className={twMerge('pt-1 text-xs font-bold', expiredNumber > 0 ? 'text-error' : 'text-c-card-muted')}>
          {expiredNumber} EXPIRED domain{expiredNumber !== 1 ? 's' : ''}
        </Text>
      </div>
    );
  }, [expiredNumber]);

  return (
    <WidgetLayout
      title={dashboardWidgetsPermissionConfig['expiring_domains_agreements'].name}
      icon={Globe}
      viewAllLink="/domains"
      viewAllText="View All Domains"
      className={className}
      fallback={fallback}
      headerRightSlot={headerRight()}
      footerLeftSlot={footerLeft()}
      bodyClassName="3xl:pr-1 pr-0.5"
      descriptionClassName="max-h-[480px] pr-4 overflow-y-auto"
    >
      {children}
    </WidgetLayout>
  );
}
